import { isBrowser } from 'react-device-detect';
import SubvencionsGrantActions from './SubvencionsGrantActions';

function decodeHtmlEntities(text) {
    if (!text) return text;
    const el = document.createElement('textarea');
    el.innerHTML = text;
    return el.value;
}

const STATUS_LABELS = {
    open: 'Oberta',
    pending: "Pendent d'obrir",
    waiting: "A l'espera",
    closed: 'Fora de termini',
    unknown: 'Desconegut',
};

function daysUntil(dateStr) {
    if (!dateStr) return null;
    const now = new Date();
    const target = new Date(dateStr);
    const diff = Math.ceil((target - now) / (1000 * 60 * 60 * 24));
    return diff > 0 ? diff : null;
}

function SubvencionsGrantCard({ grant, color, isSelected, onSelect }) {
    const closeDays = grant.status === 'open' ? daysUntil(grant.closeAt) : null;
    const openDays = grant.status === 'pending' ? daysUntil(grant.openAt) : null;
    const grantColor = color || '#9e9e9e';
    const isClosed = grant.status === 'closed';
    const hasInternalGuide = grant.canonicalSlug === 'clt027';
    const guideHref = hasInternalGuide ? `/subvencions/${grant.canonicalSlug}` : null;

    return (
        <div
            id={`subvencions-grant-${grant.slug}`}
            onClick={onSelect}
            className="subvencions-grant-card"
            style={{
                backgroundColor: '#fff',
                padding: 16,
                borderRadius: 10,
                borderLeft: `4px solid ${isClosed ? '#ccc' : grantColor}`,
                boxShadow: isSelected
                    ? `0 0 0 2px ${grantColor}, 0 4px 12px rgba(0,0,0,0.12)`
                    : '0 2px 4px rgba(0,0,0,0.08)',
                marginBottom: 12,
                cursor: 'pointer',
                transition: 'box-shadow 0.2s',
                opacity: isClosed ? 0.65 : 1,
            }}
        >
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                flexWrap: 'wrap',
                gap: 10,
            }}>
                <div style={{ flex: 1, minWidth: 200 }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                        marginBottom: 8,
                        flexWrap: 'wrap',
                    }}>
                        <span style={{
                            display: 'inline-block',
                            padding: '3px 10px',
                            borderRadius: 12,
                            backgroundColor: grantColor,
                            color: '#fff',
                            fontSize: 12,
                            fontWeight: 600,
                        }}>
                            {STATUS_LABELS[grant.status] || grant.statusLabel}
                        </span>
                        {closeDays !== null ? (
                            <span style={{
                                fontSize: 13,
                                color: closeDays <= 7 ? '#d32f2f' : '#666',
                                fontWeight: closeDays <= 7 ? 600 : 400,
                            }}>
                                Queden {closeDays} {closeDays === 1 ? 'dia' : 'dies'}
                            </span>
                        ) : null}
                        {openDays !== null ? (
                            <span style={{
                                fontSize: 13,
                                color: '#e65100',
                                fontWeight: 500,
                            }}>
                                Obre en {openDays} {openDays === 1 ? 'dia' : 'dies'}
                            </span>
                        ) : null}
                        {grant.sourceAgency ? (
                            <span style={{
                                display: 'inline-block',
                                padding: '3px 9px',
                                borderRadius: 12,
                                backgroundColor: '#f5f5f5',
                                color: '#666',
                                fontSize: 12,
                                fontWeight: 600,
                            }}>
                                {grant.sourceAgency}
                            </span>
                        ) : null}
                    </div>
                    <h4 style={{
                        margin: '0 0 8px 0',
                        fontSize: 16,
                        color: '#333',
                        lineHeight: 1.4,
                        fontWeight: 500,
                    }}>
                        {grant.title}
                    </h4>
                    <div style={{ fontSize: 14, color: '#666' }}>
                        📅 {grant.dateRangeLabel}
                        {grant.closeTimeLabel ? ` (tanca a les ${grant.closeTimeLabel})` : ''}
                    </div>
                    {isBrowser && grant.summary ? (() => {
                        const decoded = decodeHtmlEntities(grant.summary);
                        return (
                            <p style={{
                                fontSize: 14,
                                color: '#555',
                                lineHeight: 1.5,
                                margin: '8px 0 0 0',
                            }}>
                                {decoded.length > 250
                                    ? decoded.substring(0, 250) + '...'
                                    : decoded}
                            </p>
                        );
                    })() : null}
                </div>
                <SubvencionsGrantActions
                    grant={grant}
                    color={grantColor}
                    guideHref={guideHref}
                    onActionClick={(e) => e.stopPropagation()}
                />
            </div>
        </div>
    );
}

export default SubvencionsGrantCard;
